import { render, staticRenderFns } from "./BridgesTable.vue?vue&type=template&id=41cd5de0"
import script from "./BridgesTable.vue?vue&type=script&lang=js"
export * from "./BridgesTable.vue?vue&type=script&lang=js"
import style0 from "./BridgesTable.vue?vue&type=style&index=0&id=41cd5de0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports